import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { IX_DATE_FORMATS } from 'ix-ng-static-utils';

/**
 * globalni format za datume brez vodilnih ničel
 */
IX_DATE_FORMATS.dateFormat = 'D.M.yyyy';
IX_DATE_FORMATS.dateTimeFormat = 'D.M.YYYY HH:mm';
IX_DATE_FORMATS.dateTimeSecondsFormat = 'D.M.YYYY HH:mm:ss';
IX_DATE_FORMATS.dateTimeIxCalendarFormat = 'd.m.yy';
IX_DATE_FORMATS.dateTimeSecondsFormatWijmo = 'd.M.yyyy HH:mm:ss';

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
